<template>
  <simple-links :menu-items="menuItems" />
</template>

<script>
import { mapGetters } from 'vuex'
import SimpleLinks from '@/components/sidebar/SimpleLinks'

export default {
  components: {
    'simple-links': SimpleLinks
  },
  computed: {
    menuItems () {
      if (this.isLoggedIn) {
        return [
          { icon: 'mdi-close', text: 'Abmelden', to: { name: 'logout' } }
        ]
      } else {
        return [
          { icon: 'mdi-lock-open-outline', text: 'Anmelden', to: { name: 'login' } }
        ]
      }
    },
    ...mapGetters({
      isLoggedIn: 'isLoggedIn'
    })
  }
}
</script>
